var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlimited = function SvgUnlimited(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1434CB",
    d: "M15.498 3.75a3.75 3.75 0 0 1-6.402 2.652l-.03-.033-3.742-4.224a2.25 2.25 0 1 0 0 3.211l.192-.217a.75.75 0 1 1 1.125.994l-.209.236-.03.033a3.75 3.75 0 1 1 0-5.303l.03.033 3.741 4.224a2.25 2.25 0 1 0 0-3.211l-.192.217a.75.75 0 0 1-1.125-.994l.21-.236.03-.033a3.75 3.75 0 0 1 6.402 2.651"
  })));
};
export default SvgUnlimited;